import { axiosRequest } from '@planbord/axios-request';
import { useMutation } from '@tanstack/vue-query';

export const useAddPerson = () => {
  const baseUrl = '/api';

  return useMutation({
    mutationFn: (value: { Id: number; PersonId: string }) =>
      axiosRequest
        .put(`${baseUrl}/addPerson/${value.Id}`, value.PersonId)
        .then((res) => {
          return res.data;
        }),
  });
};
